import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds,    MobileUnderCalAds } from "../../Ads";
import { SERVER_URL } from '../ConstantsEN';
import { Calories_EndPoint } from '../ConstantsEN';
import { CalculatorsType } from '../ConstantsEN';
import CaloriesTable from './CaloriesTable';
import SharedHelmet from "../Helmet";
const TITLE = 'Calorie Deficit Calculator | Lose or Gain Weight';
const DESCRIPTION = 'With the calorie deficit calculator, you can find out how many calories you have consumed during the day within your diet. Enter your data and discover now.';
const KEYWORDS = 'How to calculate the calories the body needs, calorie deficit calculator,how to calculate body calorie needs, calculate daily calories needed, calculate calories by weight, calorie calculation equation, calorie calculation application';
const OG_URL = 'https://do-calculate.com/calculator/en/calories/';
const apiEndpoint = `${SERVER_URL}/${Calories_EndPoint}`;
function CaloriesCalculator() {
    const [weight, setWeight] = useState('');
    const [height, setHeight] = useState('');
    const [age, setAge] = useState('');
    const [gender, setGender] = useState('');
    const [result, setRestul] = useState(null);
    const [error, setError] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [classification, setClassification] = useState(null)
    const [activity, setActivity] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const handleWeightChange = (event) => {
        setWeight(event.target.value);
    };
    const handleHeightChange = (event) => {
        setHeight(event.target.value);
    };
    const handleAgeChange = (event) => {
        setAge(event.target.value);
    };
    const handleGenderChange = (event) => {
        setGender(event.target.value);
    };
    const handleActivityChange = (event) => {
        setActivity(event.target.value);
    };
    const calculateCalories = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ activity, weight, height, age, gender }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setRestul(data.result);
                setError(null);
                setClassification(data.result.classification);
            } else {
                setRestul(null);
                setError(data.error);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div>
  <SharedHelmet
             TITLE={TITLE}
             DESCRIPTION={DESCRIPTION}
             KEYWORDS={KEYWORDS}
             OG_URL={OG_URL}
           />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '32px' }}>
                        <h1 style={{ fontSize: '16px' }}>{TITLE}</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                        The calorie deficit calculator is a useful tool for estimating the daily calorie needs of an individual. You can calculate the calories specific to your body and estimate how many calories your body needs. You can also use this calculator to determine the calories needed for weight loss or gain.
                                        <br />
                                        This calculator takes into account factors such as physical activity level, weight, height, age, and gender to provide personalized calorie recommendations for your individual needs. Additionally, it offers simple guidance for weight management, including weight loss or gain and achieving a healthy balance based on the calories your body needs daily.
                                        <br />
                                        Use the calorie calculator to find out how many calories your body needs to maintain a healthy weight and an active lifestyle.
                                        <hr />
                                    </div>
                                    <br />
                                </div>
                                <MobileUnderCalAds />
                                <div className="row">
                                    <div className="col-sm-12 col-md-5 calculatorStyle">
                                        <div className='p-3 mb-2 bg-success text-white'>
                                            Calories for Weight Gain/Loss
                                        </div>
                                        <hr />
                                        <br />
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label htmlFor='height' className="form-label ms-2">Height</label>
                                            </b>
                                            <input
                                                type="number"
                                                id="height"
                                                value={height}
                                                onChange={handleHeightChange}
                                                className="form-control ml-2"
                                                style={{ width: '75px' }}
                                                placeholder="175"
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">cm</span>
                                            </div>
                                        </div>
                                        <br />
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label htmlFor='weightNumber' className="form-label ms-2">Weight</label>
                                            </b>
                                            <input
                                                type="number"
                                                id="weightNumber"
                                                value={weight}
                                                onChange={handleWeightChange}
                                                className="form-control ml-2"
                                                style={{ width: '75px' }}
                                                placeholder="65"
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">kg</span>
                                            </div>
                                        </div>
                                        <br />
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label htmlFor='age' className="form-label ms-2">Age</label>
                                            </b>
                                            <input
                                                type="number"
                                                id="age"
                                                value={age}
                                                onChange={handleAgeChange}
                                                className="form-control"
                                                style={{ width: '75px' }}
                                                placeholder="6"
                                                min="2"
                                                max="20"
                                            />
                                        </div>
                                        <br />
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label >Gender</label>
                                            </b>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    type="radio"
                                                    name="gender"
                                                    value="male"
                                                    id="male"
                                                    checked={gender === "male"}
                                                    onChange={handleGenderChange}
                                                    className="form-check-input"
                                                />
                                                <label className="form-check-label" htmlFor="male">
                                                    Male
                                                </label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    type="radio"
                                                    name="gender"
                                                    value="female"
                                                    id="female"
                                                    checked={gender === "female"}
                                                    onChange={handleGenderChange}
                                                    className="form-check-input"
                                                />
                                                <label className="form-check-label" htmlFor="female">
                                                    Female
                                                </label>
                                            </div>
                                        </div>
                                        <br />
                                        <div>
                                            <b>
                                                <label htmlFor="activitySelect" className="form-label ms-2">Activity Level</label>
                                            </b>
                                           <select id="activitySelect" className="form-select" value={activity} onChange={handleActivityChange} >
                                                <option value="">-- Select Activity --</option>
                                                <option value="sedentary">Sedentary: Very little physical activity or no exercise</option>
                                                <option value="lightlyActive">Lightly Active: Light exercise or physical activity for 1-3 days a week</option>
                                                <option value="moderatelyActive">Moderately Active: Moderate exercise or physical activity for 3-5 days a week</option>
                                                <option value="active">Active: Intensive exercise or physical activity for 6-7 days a week</option>
                                                <option value="veryActive">Very Active: Very intensive exercise or strong physical activity daily</option>
                                            </select>
                                        </div>
                                        <br />
                                        <hr />
                                        <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={
                                            calculateCalories} disabled={isLoading}>
                                            {isLoading ? (
                                                <div className="spinner-border spinner-border-sm" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            ) : (
                                                'Calculate'
                                            )}
                                        </button>
                                    </div>
                                    <div className="col-sm-12 col-md-7">
                                        {result && (
                                            <div>
                                                <div className="alert alert-success">
                                                    <h5>Results:</h5>
                                                </div>
                                                <hr />
                                                <CaloriesTable caloriesBurned={result.caloriesBurned}
                                                    bmr={result.bmr}
                                                    maintain={result.dailyCalories.maintain}
                                                    mildLoss={result.dailyCalories.mildLoss}
                                                    lose={result.dailyCalories.lose}
                                                    extremeLoss={result.dailyCalories.extremeLoss}
                                                    mildGain={result.dailyCalories.mildGain}
                                                    gain={result.dailyCalories.gain}
                                                    extremeGain={result.dailyCalories.extremeGain}></CaloriesTable>  <br />
                                                <div className="alert alert-warning">
                                                    When you lose 0.5 kg or more per week, please consult a doctor.
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <br />
                                        {statusCode === 400 && <div className="alert alert-warning"><b><u> Error Occurred:</u></b> Please enter all fields correctly.</div>}
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <RelatedLinks />
                                    <hr />
                                </div>
                            </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.healthCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">Calorie Calculator - How Many Calories Does the Body Need:</div>
                            <div className="info-section-body">
                                <u><h2 style={{ fontSize: '16px' }}>Calories and How to Calculate Them for Proper Nutrition</h2></u><br />
                                <p>
                                    Calories are one of the most important concepts in the world of nutrition and health. Knowing how many calories your body needs can be key to achieving proper nutrition and maintaining a healthy weight. In this article, we will learn how to calculate the calories your body needs and their importance in maintaining your health.
                                </p>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>What Are Calories?</h2></u><br />
                                <p>
                                    Calories are units of energy. They are the energy your body uses to perform its basic functions such as breathing, pumping blood, and other organ functions. It also requires energy for any physical activity or movement, whether you are exercising in the gym or performing daily tasks.
                                </p>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>How to Calculate the Calories Your Body Needs</h2></u><br />
                                    There are many ways to calculate the calories your body needs, but the most common method is based on the following factors:
                                    <ul>
                                        <li>
                                            Weight: The more you weigh, the higher your body's calorie needs to maintain its vital functions.
                                        </li>
                                        <li>
                                            Height: Taller individuals usually need more calories due to more cells and tissues in their bodies.
                                        </li>
                                        <li>
                                            Age: As you age, you may need fewer calories due to changes in metabolism.
                                        </li>
                                        <li>
                                            Physical Activity: People who exercise regularly need more calories to meet their physical activity needs.
                                        </li>
                                    </ul>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>Calorie Calculation Application:</h2></u><br />
                                <p>
                                    You can also use smartphone apps and online tools to calculate your daily calorie needs based on your personal information. These apps make the process easier and more accurate.
                                    In summary, understanding calories and how to calculate them is essential for taking care of your health and maintaining a healthy weight. Make sure to meet your body's calorie needs and choose healthy foods that contain the necessary nutrients for achieving nutritional balance and overall health.
                                </p>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>Calorie Calculation Equation:</h2></u><br />
                                    Basal Metabolic Rate (BMR) is calculated based on age, weight, height, and gender using the modified Harris-Benedict formula. The Harris-Benedict equation was one of the earliest equations used to calculate Basal Metabolic Rate (BMR), which is the amount of energy expended daily at rest. It was revised in 1984 to be more accurate.
                                    <br /> <hr />
                                    <b>Revised Harris-Benedict Equation:</b>
                                    <br />
                                    <div className='alert alert-info text-center'>
                                        <b><u>Males:</u></b> <label>Basal Metabolic Rate (BMR) = 13.397W + 4.799H - 5.677A + 88.362</label> <br />
                                        <b><u>Females:</u></b> <label>Basal Metabolic Rate (BMR) = 13.397W + 4.799H - 5.677A + 88.362</label>
                                    </div>
                                    <div>
                                        Where:
                                        <ul>
                                            <li>W is body weight in kilograms</li>
                                            <li>H is body height in centimeters</li>
                                            <li>A is age</li>
                                            <li>F is body fat percentage</li>
                                        </ul>
                                    </div>
                                    <br />
                                    <hr />
                                    Total calories burned are calculated based on activity level and Basal Metabolic Rate (BMR).
                                    <br />
                                    Daily calorie estimates are calculated based on desired weight goals, including weight maintenance, weight loss, and weight gain.
                                    <hr />
                                    <p>
                                        This calculator calculates the number of calories burned and Basal Metabolic Rate (BMR) based on activity level, weight, height, age, and gender. For children and youth aged 2 to 20, the Body Mass Index calculator takes into account age, gender, height, and weight.
                                    </p>
                            </div>
                        </div>
                    </div>
                    <br />
                    <u><h2>Frequently Asked Questions</h2></u>
                    <br />
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>How Many Calories Do You Need?</h3>
                            </div>
                            <div className="info-section-body">
                                The number of calories you need depends on your age, body size, and activity level. Most teenagers and adults need about 1500 to 2500 calories per day. The larger you are, the more calories you need to maintain your weight. If you want to gain weight, you'll need to consume more calories, and if you want to lose weight, you'll need to consume fewer calories or engage in more physical activity. You can calculate your calorie needs using the Harris-Benedict formula.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>How Many Calories Are in Fat?</h3>
                            </div>
                            <div className="info-section-body">
                                Fat contains approximately 9 calories per gram, making it one of the high-calorie sources. When consuming fats in large quantities, they can contribute to an increase in daily calorie intake and, therefore, weight gain if not enough physical activity is performed to burn them.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>What Is the Impact of Physical Activities on Calories?</h3>
                            </div>
                            <div className="info-section-body">
                                Movement, lifting things, and performing various activities require energy, so the more you move and the more things you lift, push, or pull, the more calories you need for energy purposes. Additionally, endurance training that increases muscle mass boosts metabolism, meaning your body needs more calories, even when not engaging in many activities. Therefore, building muscle is a good way to help you achieve a healthy weight.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>How Accurate Are Calorie Calculators?</h3>
                            </div>
                            <div className="info-section-body">
                                Calorie calculators are reasonably accurate but may not be 100% precise. Most are based on the Harris-Benedict formula, which determines the Basal Metabolic Rate (BMR), essentially the number of calories you need just to stay alive and awake. Calorie calculators also need to consider your usual daily activity levels, which might be an overestimation. It's difficult to know exactly how many calories you burn with physical activity, and it may vary daily. These calorie calculators are a good starting point, but if you feel your weight isn't changing sufficiently, you may need to adjust your daily calorie intake or expenditure as needed.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>What Is the Best Way to Track Calories?</h3>
                            </div>
                            <div className="info-section-body">
                                You can use a paper notebook or food journal to manually search for calorie counts and calculate them. However, the best way currently is to use a website or calorie tracking app like MyFitnessPal. You can select the foods you eat and the beverages you drink, and the website will calculate the calorie counts and provide you with daily nutritional estimates. Additionally, you can track the calories your body burns daily, and it's free.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>What Does "Not All Calories Are Equal" Mean?</h3>
                            </div>
                            <div className="info-section-body">
                                All calories are equal in terms of energy. Every gram of carbohydrates contains four calories, every gram of protein contains four calories, and every gram of fat contains nine calories. That doesn't change. The phrase "Not all calories are equal" means that some calorie sources are better than others. In short, you should get most of your calories from nutrient-rich foods. So, while 250 calories of chocolate may be used the same way as 250 calories from a banana, apple, or pear combined, fruit is, of course, considered better for your health.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default CaloriesCalculator;
